import { InfoBarMessageSource, InfoBarMessageRank, } from 'owa-info-bar/lib/schema/InfoBarMessageViewState';
import { getUpgradeToPremiumButton, getHipVerifyButton, getAccountRecoveryFlowButton, } from './wasclUtils';
import removeProtection from './removeProtection';
import shouldDisableEncryptionButton from './shouldDisableEncryptionButton';
import infoBarStrings from 'owa-strings/owa-common-strings';
import strings from 'owa-strings/owa-mail-strings';
import { format } from 'owa-strings';
import infoBarMessageCreatorsMap from './infoBarMessageCreatorsMap';
import protectMessage from '../actions/protectMessage';
import { getStore } from '../store/composeStore';
import { ENCRYPT_GUID } from '../store/schema/EncryptionGUID';
import removeInfoBarMessage from '../actions/removeInfoBarMessage';
import { getUserConfiguration } from 'owa-session-store';
var ENCRYPT_LEARN_MORE = 'https://go.microsoft.com/fwlink/?linkid=867644';
function createInfoBarViewState(messageId, messages, rank) {
    if (rank === void 0) { rank = InfoBarMessageRank.Error; }
    return {
        key: messageId,
        source: InfoBarMessageSource.Compose,
        rank: rank,
        messageParts: messages,
    };
}
export default function getInfoBarMessageViewState(messageId, composeViewState) {
    var messages = [];
    var rank;
    var composeId = composeViewState.composeId;
    var isPremiumConsumerMailbox = getUserConfiguration().SessionSettings
        .IsPremiumConsumerMailbox;
    var infoBarMessageViewCreator = infoBarMessageCreatorsMap[composeId] && infoBarMessageCreatorsMap[composeId][messageId];
    if (infoBarMessageViewCreator) {
        if (typeof infoBarMessageViewCreator === 'function') {
            return infoBarMessageViewCreator(composeViewState);
        }
        else {
            messages = infoBarMessageViewCreator;
        }
    }
    else {
        switch (messageId) {
            // Up convert
            case 'warningNoQuotedBody':
                messages = [infoBarStrings.warningUpgradeMessage];
                break;
            // Client send validation
            case 'errorMessageNoRecipentsMailCanNotBeSend':
                messages = [infoBarStrings.errorMessageNoRecipentsMailCanNotBeSend];
                break;
            case 'warningMessageMaxRecipientsExceed':
                messages = [infoBarStrings.warningMessageMaxRecipientsExceed];
                break;
            case 'errorMessageFileCanNotBeSaved':
                messages = [strings.UnableToSaveMessage];
                break;
            // Server side error message
            case 'errorMessageNoPermissionToSendAs':
                messages = [infoBarStrings.errorMessageNoPermissionToSendAs];
                break;
            case 'errorMessageSubmissionQuotaExceededMessageCanNotBeSent':
                messages = [infoBarStrings.errorMessageSubmissionQuotaExceededMessageCanNotBeSent];
                break;
            case 'errorMessageItemNoLongerExistToSend':
                messages = [infoBarStrings.errorMessageItemNoLongerExistToSend];
                break;
            case 'errorMessageItemNoLongerExistToSave':
                messages = [infoBarStrings.errorMessageItemNoLongerExistToSave];
                break;
            case 'warningMessageNoPermissionToPerformAction':
                messages = [infoBarStrings.warningMessageNoPermissionToPerformAction];
                break;
            case 'errorMessageQuotaExceededMessageCanNotBeSent':
                messages = [infoBarStrings.errorMessageQuotaExceededMessageCanNotBeSent];
                break;
            case 'errorMessageQuotaExceededMessageCanNotBeSaved':
                messages = [infoBarStrings.errorMessageQuotaExceededMessageCanNotBeSaved];
                break;
            case 'errorMessageMessageCanNotBeSent':
                messages = [infoBarStrings.errorMessageMessageCanNotBeSent];
                break;
            case 'errorMessageMessageCanNotBeSaved':
                messages = [infoBarStrings.errorMessageMessageCanNotBeSaved];
                break;
            case 'error500':
                messages = [infoBarStrings.error500];
                break;
            case 'error503':
                messages = [infoBarStrings.error503];
                break;
            case 'errorFailedToFetch':
                messages = [infoBarStrings.errorFailedToFetch];
                break;
            case 'errorSessionTimeout':
                messages = [infoBarStrings.errorSessionTimeout];
                break;
            case 'errorMailboxStoreUnavailable':
                messages = [infoBarStrings.errorMailboxStoreUnavailable];
                break;
            // Wascl related error message
            case 'errorMessageAccountSuspend':
                messages = [
                    infoBarStrings.errorMessageAccountSuspend,
                    getAccountRecoveryFlowButton(composeViewState),
                ];
                break;
            case 'errorMessageExceededMaxRecipientLimit':
                if (isPremiumConsumerMailbox) {
                    messages = [infoBarStrings.errorMessageExceededMaxRecipientLimitPremium];
                }
                else {
                    messages = [
                        infoBarStrings.errorMessageExceededMaxRecipientLimit,
                        getUpgradeToPremiumButton(composeViewState),
                    ];
                }
                break;
            case 'errorMessageExceededMessageLimit':
                if (isPremiumConsumerMailbox) {
                    messages = [infoBarStrings.errorMessageExceededMessageLimitPremium];
                }
                else {
                    messages = [
                        infoBarStrings.errorMessageExceededMessageLimit,
                        getUpgradeToPremiumButton(composeViewState),
                    ];
                }
                break;
            case 'errorMessageExceededHourlyMessageLimit':
                messages = [infoBarStrings.errorMessageExceededHourlyMessageLimit];
                break;
            case 'errorMessageMessageBlocked':
                messages = [infoBarStrings.errorMessageMessageBlocked];
                break;
            case 'errorMessageMessageSubmissionBlocked':
                messages = [
                    infoBarStrings.errorMessageMessageSubmissionBlocked,
                    getHipVerifyButton(composeViewState),
                ];
                break;
            case 'errorMessageAccountSuspendShowTierUpgrade':
                messages = [
                    infoBarStrings.errorMessageAccountSuspendShowTierUpgrade,
                    getAccountRecoveryFlowButton(composeViewState),
                ];
                break;
            case 'errorMessageExceededMaxRecipientLimitShowTierUpgrade':
                messages = [
                    infoBarStrings.errorMessageExceededMaxRecipientLimitShowTierUpgrade,
                    getHipVerifyButton(composeViewState),
                ];
                break;
            case 'errorMessageExceededMessageLimitShowTierUpgrade':
                messages = [
                    infoBarStrings.errorMessageExceededMessageLimitShowTierUpgrade,
                    getHipVerifyButton(composeViewState),
                ];
                break;
            case 'errorMessageTimeout':
                messages = [format(infoBarStrings.errorMessageTransientError, '(0x00000002)')];
                break;
            case 'errorMessageThrottled':
                messages = [format(infoBarStrings.errorMessageTransientError, '(0x00000008)')];
                break;
            case 'errorMessageTransientError':
                messages = [format(infoBarStrings.errorMessageTransientError, '(0x00004000)')];
                break;
            // IRM protection
            case 'encryption':
                messages = [infoBarStrings.cmpEncryptMessage];
                if (composeViewState.IRMData.IsOwner) {
                    messages.push(removeProtection(composeViewState, 'encryption'));
                    messages.push('|');
                }
                messages.push(getEncryptionTips());
                rank = InfoBarMessageRank.Encryption;
                break;
            case 'encryptionDoNotForward':
                messages = [infoBarStrings.cmpEncryptMessageDNF];
                if (composeViewState.IRMData.IsOwner) {
                    messages.push(removeProtection(composeViewState, 'encryptionDoNotForward'));
                    messages.push('|');
                }
                messages.push(getEncryptionTips());
                rank = InfoBarMessageRank.Encryption;
                break;
            case 'dlpPolicyTips':
                messages = [infoBarStrings.cmpEncryptionDlpPolicyTips];
                // If compliance configuration is not ready, do not show the confirm encryption link
                if (!shouldDisableEncryptionButton(composeViewState, ENCRYPT_GUID)) {
                    messages.push(confirmEncryptMessage(composeViewState));
                    messages.push('|');
                }
                messages.push(getEncryptionTips());
                rank = InfoBarMessageRank.Encryption;
                break;
            // Default
            default:
                break;
        }
    }
    return createInfoBarViewState(messageId, messages, rank);
}
function getEncryptionTips() {
    return {
        text: infoBarStrings.cmpEncryptionTips,
        action: function () {
            window.open(ENCRYPT_LEARN_MORE, '_blank');
        },
    };
}
function confirmEncryptMessage(composeViewState) {
    var storeState = getStore();
    return {
        text: infoBarStrings.cmpDlpConfirmEncryption,
        action: function () {
            removeInfoBarMessage(composeViewState, 'dlpPolicyTips');
            protectMessage(composeViewState, storeState.complianceConfigurations, ENCRYPT_GUID);
        },
    };
}
//# sourceMappingURL=getInfoBarMessageViewState.js.map